import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import {
  ChangeOrder,
  updateChangeOrderAsync,
} from '../../modules/change-orders';
import { getPCCOFileAPIPath, initializeUploadProps } from '../../util/utils';
import PCCOCreateUpdateComponent from '../../components/contracts/PCCOCreateUpdateComponent';
import { getExpenseConfig } from '../../api/constlink';
import { Drawer } from 'antd';

interface PCCOEditDrawerProps {
  config: any;
  visible: boolean;
  onClose: () => void;
}

function PCCOEditDrawer({ config, visible, onClose }: PCCOEditDrawerProps) {
  const dispatch = useDispatch();
  const [uploadProps, setUploadProps] = useState<any>();
  const [expenseConfig, setExpenseConfig] = useState<any>();
  const primeContract = useSelector(
    (state: RootState) => state.contracts.contract.data,
  );

  const changeOrderData: ChangeOrder = useSelector(
    (state: RootState) => state.changeOrders.changeOrder.data,
  ) as ChangeOrder;

  useEffect(() => {
    if (primeContract === null) return;
    (async () => {
      setUploadProps(
        await initializeUploadProps(
          getPCCOFileAPIPath(
            config.enterpriseId,
            config.projectId,
            '' + primeContract.id,
          ),
        ),
      );
      setExpenseConfig(
        await getExpenseConfig({ enterpriseId: config.enterpriseId }),
      );
    })();
  }, [config, primeContract]);

  const onFinish = (changeOrder: ChangeOrder) => {
    if (primeContract === null) return;
    const changeOrderObj: ChangeOrder = {
      ...changeOrderData,
      ...changeOrder,
      changeDate: moment(changeOrder.changeDate).format('YYYY-MM-DD'),
    };
    changeOrderObj.projectId = config.projectId;
    changeOrderObj.contractId = '' + primeContract.id;
    for (const _file of changeOrderObj.file) {
      if ('response' in _file) {
        _file.path = _file.response.path;
        _file.mimeType = _file.response.mimeType;
      }
    }

    dispatch(
      updateChangeOrderAsync.request({
        enterpriseId: config.enterpriseId,
        projectId: config.projectId,
        contractId: '' + primeContract.id,
        changeOrderId: '' + changeOrderObj.id,
        contractType1: changeOrderObj.type,
        changeOrder: changeOrderObj,
      }),
    );
    onClose();
  };

  const onCancel = () => {
    onClose();
  };

  return (
    <>
      {changeOrderData && primeContract && uploadProps && expenseConfig && (
        <Drawer
          width={600}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          {visible && (
            <PCCOCreateUpdateComponent
              uploadProps={uploadProps}
              data={changeOrderData}
              primeContract={primeContract}
              gongjongs={expenseConfig.gongjong}
              onFinish={onFinish}
              onCancel={onCancel}
            />
          )}
        </Drawer>
      )}
    </>
  );
}

export default PCCOEditDrawer;
